import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-mat-input-validate-messages',
	template: `
		<div class="mat-form-field-subscript-wrapper" style="margin-top: 2.5em">
			<mat-error>
				<span *ngFor="let message of messages">{{ message }}</span>
			</mat-error>
		</div>
	`
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class MatInputValidateMessages {
	@Input() messages: string[];

	get className() {
		return 'invalid-feedback';
	}

	constructor() {}
}
